//options: https://glidejs.com/docs/options/
import Glide from '@glidejs/glide'
import breakpoints from '../breakpoints';
import analytics from './analytics';

/**
 * Create carousel for "cards"
 */
export const init = () => {
  const cardCarousels = document.querySelectorAll('.card-carousel .glide');

  cardCarousels.forEach(carousel => {
    const glide = new Glide(carousel, {
      type: 'slider',
      startAt: 0,
      perView: 4,
      gap: 20,
      keyboard: false,//keyboard arrows controlled carousel even if it was not selected
      rewind: false,
      bound: true,
      breakpoints: {
        [breakpoints.xl]: {
          perView: 3,
          gap: 15,
        },
        [breakpoints.lg]: {
          perView: 2,
          gap: 10,
          peek: 0
        },
        [breakpoints.md]: {
          peek: { before: 16, after: 32 },
          perView: 2,
          gap: 10,
        },
        [breakpoints.xs]: {
          peek: 16,
          perView: 1,
          gap: 5
        }
      }

    });

    analytics.carouselAnalytics(carousel, 'card carousel');

    //unfortunately glidejs doesen't disable buttons by default so we have to have a custom component for it: https://github.com/glidejs/glide/issues/307
    function arrowDisabler (Glide, Components) {
      return {
        mount() {
          // Only in effect when rewinding is disabled
          if (Glide.settings.rewind) {
            return
          }

          Glide.on(['mount.after', 'run'], () => {
            // Filter out arrows_control
            for (let controlItem of Components.Controls.items) {

              if (controlItem.getAttribute('data-glide-el') !== 'controls') {
                continue
              }

              // Set left arrow state
              var left = controlItem.querySelector('[data-glide-dir="<"]')
              if (left) {
                if (Glide.index === 0) {
                  left.setAttribute('disabled', '') // Disable on first slide
                } else {
                  left.removeAttribute('disabled') // Enable on other slides
                }
              }

              // Set right arrow state
              var right = controlItem.querySelector('[data-glide-dir=">"]')
              if (right) {
                // Glide.index is based on the active slide
                // For bound: true, there will be no empty space & the last slide will never become active
                // Hence add perView to correctly calculate the last slide
                const lastSlideIndex = Glide.settings.bound
                  ? Glide.index + (Glide.settings.perView - 1)
                  : Glide.index;

                if (lastSlideIndex >= Components.Sizes.length - 1) {
                  right.setAttribute('disabled', '') // Disable on last slide
                } else {
                  right.removeAttribute('disabled') // Disable on other slides
                }
              }
            }
          })
        }
      }
    }

    glide.mount({ arrowDisabler });
  });

}
